<template>
  <div id="pers-tab2-1" name="hres32e-tab2-tab1">

    <div class="col-xs-12 col-md-6 pull-left">
      <div class="col-xs-12  card-ui clearfix border-top-color-skin">
        <div class="sub-topic-box clearfix" @click="toggleSubTopic1">
          <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
          <div class="sub-topic">{{ labels['HRES32EC3']['20'] }}</div>
        </div>
        <div class="data-box clearfix" v-show="subTopic1">
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC3']['100'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="adrreg" name="adrreg" 
                     v-model="detail.adrreg"
                     maxlength="100" 
                     v-validate="'max:100'"
                     data-vv-name="adrreg"
                     data-vv-as="adrreg"
                     :has-error="errors.has('adrreg')" />
              <div class="text-error" v-show="errors.has('adrreg')">{{errors.first('adrreg')}}</div>
            </div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC3']['80'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.codcntyr"
                                :options="dropdowns.codcount[nowLang]"
                                style="margin-bottom: 5px;" />
            </div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC3']['70'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.codprovr"
                                :options="dropdowns.codprovr[nowLang]"
                                style="margin-bottom: 5px;" />
            </div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC3']['60'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.coddistr"
                                :options="arrCoddistr[nowLang]"
                                style="margin-bottom: 5px;" />
            </div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC3']['50'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.codsubdistr"
                                :options="arrCodsubdistr[nowLang]"
                                style="margin-bottom: 5px;"/>
            </div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC3']['90'] }}</div>
            <div class="col-xs-7 data-input">
                <input type="text" class="form-control input-text" id="codpostr" name="codpostr" 
                       v-model="detail.codpostr"
                       maxlength="5" 
                       v-validate="'numeric|max:5'"
                       data-vv-name="codpostr"
                       data-vv-as="codpostr"
                       :has-error="errors.has('codpostr')" />
                <div class="text-error" v-show="errors.has('codpostr')">{{errors.first('codpostr')}}</div>
            </div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC3']['170'] }}</div>
            <div class="col-xs-7 data-input">
                <input type="text" class="form-control input-text" id="email_emp" name="email_emp" 
                       v-model="detail.email_emp"
                       maxlength="50" 
                       v-validate="'max:50'"
                       data-vv-name="email_emp"
                       data-vv-as="email_emp"
                       :has-error="errors.has('email_emp')" />
                <div class="text-error" v-show="errors.has('email_emp')">{{errors.first('email_emp')}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xs-12 col-md-6 pull-right">
      <div class="col-xs-12  card-ui clearfix border-top-color-skin">
        <div class="sub-topic-box clearfix" @click="toggleSubTopic2">
          <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
          <div class="sub-topic">{{ labels['HRES32EC3']['30'] }}</div>
        </div>
        <div class="data-box clearfix" v-show="subTopic2">
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC3']['100'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="adrcont" name="adrcont" 
                     v-model="detail.adrcont"
                     maxlength="100" 
                     v-validate="'max:100'"
                     data-vv-name="adrcont"
                     data-vv-as="adrcont"
                     :has-error="errors.has('adrcont')" />
              <div class="text-error" v-show="errors.has('adrcont')">{{errors.first('adrcont')}}</div>
            </div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC3']['80'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.codcntyc"
                                :options="dropdowns.codcount[nowLang]"
                                style="margin-bottom: 5px;" />
            </div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC3']['70'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.codprovc"
                                :options="dropdowns.codprovr[nowLang]"
                                style="margin-bottom: 5px;" />
            </div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC3']['60'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.coddistc"
                                :options="arrCoddistc[nowLang]"
                                style="margin-bottom: 5px;" />
            </div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC3']['50'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.codsubdistc"
                                :options="arrCodsubdistc[nowLang]"
                                style="margin-bottom: 5px;" />
            </div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC3']['90'] }}</div>
            <div class="col-xs-7 data-input">
                <input type="text" class="form-control input-text" id="codpostc" name="codpostc" 
                       v-model="detail.codpostc"
                       maxlength="5" 
                       v-validate="'numeric|max:5'"
                       data-vv-name="codpostc"
                       data-vv-as="codpostc"
                       :has-error="errors.has('codpostc')" />
                <div class="text-error" v-show="errors.has('codpostc')">{{errors.first('codpostc')}}</div>
            </div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC3']['160'] }}</div>
            <div class="col-xs-7 data-input">
                <input type="text" class="form-control input-text" id="numtelec" name="numtelec" 
                       v-model="detail.numtelec" 
                       maxlength="20"
                       v-validate="'max:20'"
                       data-vv-name="numtelec"
                       data-vv-as="numtelec"
                       :has-error="errors.has('numtelec')" />
                <div class="text-error" v-show="errors.has('numtelec')">{{errors.first('numtelec')}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 box-footer">
      <button type="button" class="btn bg-dark-gray pull-left" @click="togglePage(0)" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
      <button type="button" class="btn bg-color-skin" @click="callSave()" v-if="validateStaappr"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hres32e-tab2-tab1',
  data () {
    return {
      subTopic1: true,
      subTopic2: true,
      arrCoddistr: {},
      arrCodsubdistr: {},
      arrCoddistc: {},
      arrCodsubdistc: {},
      objDetail: {
        coddistr: '',
        coddistc: '',
        codsubdistr: '',
        codsubdistc: ''
      }
    }
  },
  created () {
    for (var i = 0; i < this.allLang.length; i++) {
      this.arrCoddistr[this.allLang[i]] = {}
      this.arrCodsubdistr[this.allLang[i]] = {}
      this.arrCoddistc[this.allLang[i]] = {}
      this.arrCodsubdistc[this.allLang[i]] = {}
    }
  },
  mount () {
    this.erros.clear()
  },
  watch: {
    'detail.codprovr' () {
      this.arrCoddistr = this.changeDropdownCoddist(this.detail.codprovr)
    },
    'detail.codprovc' () {
      this.arrCoddistc = this.changeDropdownCoddist(this.detail.codprovc)
    },
    'dropdowns.coddistr' () {
      this.arrCoddistr = this.changeDropdownCoddist(this.detail.codprovr)
      this.detail.coddistr = this.objDetail.coddistr
      this.arrCoddistc = this.changeDropdownCoddist(this.detail.codprovc)
      this.detail.coddistc = this.objDetail.coddistc
    },
    'detail.coddistr' () {
      if (this.detail.coddistr) {
        this.objDetail.coddistr = this.detail.coddistr
      }
      this.arrCodsubdistr = this.changeDropdownCodsubdist(this.detail.codprovr, this.detail.coddistr)
    },
    'detail.coddistc' () {
      if (this.detail.coddistc) {
        this.objDetail.coddistc = this.detail.coddistc
      }
      this.arrCodsubdistc = this.changeDropdownCodsubdist(this.detail.codprovc, this.detail.coddistc)
    },
    'detail.codsubdistr' () {
      if (this.detail.codsubdistr) {
        this.objDetail.codsubdistr = this.detail.codsubdistr
      }
    },
    'detail.codsubdistc' () {
      if (this.detail.codsubdistc) {
        this.objDetail.codsubdistc = this.detail.codsubdistc
      }
    },
    'detail.adrreg' () {
      this.$validator.validate('adrreg', this.detail.adrreg).catch(e => {})
    },
    'detail.codpostr' () {
      this.$validator.validate('codpostr', this.detail.codpostr).catch(e => {})
    },
    'detail.email_emp' () {
      this.$validator.validate('email_emp', this.detail.email_emp).catch(e => {})
    },
    'detail.adrcont' () {
      this.$validator.validate('adrcont', this.detail.adrcont).catch(e => {})
    },
    'detail.codpostc' () {
      this.$validator.validate('codpostc', this.detail.codpostc).catch(e => {})
    },
    'detail.numtelec' () {
      this.$validator.validate('numtelec', this.detail.numtelec).catch(e => {})
    },
    'dropdowns.codsubdistr' () {
      this.arrCodsubdistr = this.changeDropdownCodsubdist(this.detail.codprovr, this.detail.coddistr)
      this.detail.codsubdistr = this.objDetail.codsubdistr
      this.arrCodsubdistc = this.changeDropdownCodsubdist(this.detail.codprovc, this.detail.coddistc)
      this.detail.codsubdistc = this.objDetail.codsubdistc
    },
    detail () {
      this.$nextTick(() => {
        this.errors.clear()
      })
    }
  },
  methods: {
    changeDropdownCoddist (codprov) {
      let list = []
      for (var i = 0; i < this.allLang.length; i++) {
        list[this.allLang[i]] = {}
        if (codprov !== '' && this.dropdowns.coddistr[this.allLang[i]].length) {
          let aaa = this.dropdowns.coddistr[this.allLang[i]].filter((coddistrRow) => {
            return coddistrRow.codprov === codprov
          })
          let bbb = []
          if (aaa.length > 0) {
            bbb = aaa.map((coddistrRow) => {
              return coddistrRow
            })
          }
          if (bbb.length > 0) {
            bbb.reduce((sum, row) => {
              if (typeof sum !== 'undefined') {
                list[this.allLang[i]][sum.coddist] = sum.namdist
              }
              list[this.allLang[i]][row.coddist] = row.namdist
            })
          }
        }
      }
      return list
    },
    changeDropdownCodsubdist (codprov, coddist) {
      let list = []
      for (var i = 0; i < this.allLang.length; i++) {
        list[this.allLang[i]] = {}
        if (coddist !== '' && this.dropdowns.codsubdistr[this.allLang[i]].length) {
          let aaa = this.dropdowns.codsubdistr[this.allLang[i]].filter((codsubdistRow) => {
            return codsubdistRow.coddist === coddist && codsubdistRow.codprov === codprov
          })
          let bbb = []
          if (aaa.length > 0) {
            bbb = aaa.map((codsubdistRow) => {
              return codsubdistRow
            })
          }
          if (bbb.length === 1) {
            list[this.allLang[i]][bbb[0].codsubdist] = bbb[0].namsubdist
          } else if (bbb.length > 1) {
            bbb.reduce((sum, row) => {
              if (typeof sum !== 'undefined') {
                list[this.allLang[i]][sum.codsubdist] = sum.namsubdist
              }
              list[this.allLang[i]][row.codsubdist] = row.namsubdist
            })
          }
        }
      }
      return list
    },
    toggleSubTopic1 () {
      this.subTopic1 = !this.subTopic1
    },
    toggleSubTopic2 () {
      this.subTopic2 = !this.subTopic2
    },
    saveParams () {
      return {
        p_dtereq: this.indexSelected.dtereq,
        p_numseq: this.indexSelected.numseq,
        n_adrreg: this.detail.adrreg,
        n_codcntyr: this.detail.codcntyr,
        n_codprovr: this.detail.codprovr,
        n_coddistr: this.detail.coddistr,
        n_codsubdistr: this.detail.codsubdistr,
        n_codpostr: this.detail.codpostr,
        n_email_emp: this.detail.email_emp,
        n_adrcont: this.detail.adrcont,
        n_codcntyc: this.detail.codcntyc,
        n_codprovc: this.detail.codprovc,
        n_coddistc: this.detail.coddistc,
        n_codsubdistc: this.detail.codsubdistc,
        n_codpostc: this.detail.codpostc,
        n_numtelec: this.detail.numtelec
      }
    },
    callSave () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postDetail2Tab1Save({ saveParams: this.saveParams(), searchIndex: this.searchIndex, togglePage: this.togglePage })
        }
      })
    }
  },
  props: [ 'nowLang', 'allLang', 'labels', 'detail', 'indexSelected', 'pcDisp', 'togglePage', 'toggleSubPage', 'triggerSubButton', 'labelsButton', 'dropdowns', 'postDetail2Tab1Save', 'searchIndex', 'validateStaappr' ]
}

</script>



// WEBPACK FOOTER //
// tab2_1.vue?d8d97a7a